import { Injector } from '@angular/core';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  ActionButtonOutcomesType,
  ButtonActionType,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { handleRedirection } from '../../cta-redirection.utils';
import { FormID } from '@finxone-platform/form-action';
import { GetTransactionById } from '@app/finxone-web-frontend/app/lib/actions/transactions.action';
import { ClearFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';

export function saveTransactionNote(injector: Injector, widgetAttributes: UiZoneWidgetAttributeConfig) {
  const accountService = injector.get(AccountService);
  const store = injector.get(Store);
  const alertHandlerService = injector.get(AlertHandlerService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);

  const selectedAccountId = store.selectSnapshot(AccountState.getCurrentAccountId);
  const transactionsState = store.selectSnapshot(TransactionState.getTransactions);
  const note = store.selectSnapshot(
    FormActionState.getFormActionStateWithId(FormID.SAVE_TRANSACTION_NOTE_FORM),
  )?.formData?.note;
  if (!selectedAccountId || !transactionsState.currentTransactionId || !note) {
    alertHandlerService.showAlertFn('error', 'Active account, transaction and note are required');
    return;
  }
  const payload = {
    accountId: selectedAccountId,
    transactionId: transactionsState.currentTransactionId,
    note: note,
  };
  ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_TRANSACTION_NOTE]: false });
  accountService.saveTransactionNote(payload).subscribe({
    next: () => {
      alertHandlerService.showAlertFn('success', 'Note saved successfully');
      ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_TRANSACTION_NOTE]: true });
      store.dispatch(
        new GetTransactionById(
          transactionsState?.currentTransactionNumber ?? '',
          transactionsState?.currentTransactionDetails?.id ?? '',
          transactionsState?.currentTransactionType ?? '',
          selectedAccountId,
        ),
      );
      store.dispatch(new ClearFormDataActionWithId(FormID.SAVE_TRANSACTION_NOTE_FORM));
      if (
        widgetAttributes.widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS]
      ) {
        handleRedirection(
          widgetAttributes.widgetProperties,
          injector,
          ActionButtonOutcomesType.SUCCESS,
          true,
        );
      }
    },
    error: (error) => {
      console.error('Error saving transaction note:', error);
      ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_TRANSACTION_NOTE]: true });
      store.dispatch(new ClearFormDataActionWithId(FormID.SAVE_TRANSACTION_NOTE_FORM));
      if (
        widgetAttributes.widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.FAILURE]
      ) {
        handleRedirection(
          widgetAttributes.widgetProperties,
          injector,
          ActionButtonOutcomesType.FAILURE,
          true,
        );
      }
    },
  });
}
